export const FEATURES = {
  EXPO: "expo",
  PORTALS: "portals",
  PAGES: "pages",
  FORMS: "forms",
  PASSES: "passes",
  CATERING: "catering",
  INVENTORY: "inventory",
  INVOICES: "invoices",
  BIDDING: "bidding",
  //
  CUSTOMIZATIONS: "customizations",
  SSO: "sso",
  CRM: "crm",
  LANGUAGES: "languages",
  CLONE_EVENTS: "clone_events",
  UNIQUE_CONTACTS: "unique_contacts"
};

export const INTEGRATIONS = {
  BIZZABO: {
    NAME: "Bizzabo",
    SLUG: "bizzabo"
  },
  CVENT: {
    NAME: "Cvent",
    SLUG: "cvent"
  },
  SWAPCARD: {
    NAME: "Swapcard",
    SLUG: "swapcard"
  },
  SWOOGO: {
    NAME: "Swoogo",
    SLUG: "swoogo"
  },
  EXPOPLATFORM: {
    NAME: "ExpoPlatform",
    SLUG: "expo-platform"
  },
  ASP: {
    NAME: "ASP",
    SLUG: "asp"
  },
  GLEANIN: {
    NAME: "Gleanin",
    SLUG: "gleanin"
  },
  GRIP: {
    NAME: "Grip",
    SLUG: "grip"
  },
  STOVA: {
    NAME: "Stova",
    SLUG: "stova"
  }
};

export const TYPES = {};
